<template>
    <div>
        <div class="b_head_banner">
            <div
                v-full-background-image-path:assets="'head_lines_decor.svg'"
                class="banner_image lines_decor"
            />
            <div class="banner_wrapper flex">
                <div class="banner_wrapper_inner">
                    <div class="container">
                        <div class="banner_title second_font text_center">
                            ארכיון כתבות
                        </div>
                        <div class="search_form">
                            <div class="form_wrapper">
                                <form @submit.prevent="resetArticles">
                                    <div class="form_row">
                                        <input
                                            v-model="search"
                                            class="form_control"
                                            type="text"
                                            placeholder="מה תרצה לחפש?"
                                        />
                                        <button
                                            class="btn_serarch btn_reset"
                                            type="submit"
                                        />
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="b_articles">
            <div class="container">
                <div class="page_title second_font">
                    תגיות
                </div>
                <div class="tags_wrapper">
                    <div class="tags_list flex">
                        <label
                            v-for="tag in tags"
                            :key="tag.id"
                            class="tag"
                            @change="onTagClick(tag.id)"
                        >
                            <input type="checkbox" />
                            <span>{{ tag.name }}</span>
                        </label>
                    </div>
                </div>
                <div class="page_wrapper flex">
                    <div class="articles_wrapper">
                        <article-item
                            v-for="article in articles"
                            :key="article.id"
                            :article="article"
                        />
                        <div
                            v-if="isMoreAvailable"
                            class="more_wrapper text_center"
                        >
                            <button
                                class="btn btn_template"
                                type="button"
                                @click="fetchArticles(true)"
                            >
                                טען עוד
                            </button>
                        </div>
                    </div>
                    <recommended-column />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { StatusCodes } from 'http-status-codes';
import ArticleItem from '@/components/articles/SingleItem';
import RecommendedColumn from '@/components/articles/RecommendedColumn';

export default {
    components: {
        ArticleItem,
        RecommendedColumn
    },

    async asyncData({ store: { dispatch }, error }) {
        try {
            const page = 1;
            const perPage = 10;
            const search = '';

            const [{ rows, count }, tags] = await Promise.all([
                dispatch('articles/index', {
                    page,
                    perPage,
                    search
                }),
                dispatch('articleTags/index')
            ]);

            return {
                articles: rows,
                total: count,
                page,
                perPage,
                search,
                tags,
                selectedTags: []
            };
        } catch (err) {
            if (
                err.response &&
                err.response.status !== StatusCodes.INTERNAL_SERVER_ERROR
            ) {
                return error({ statusCode: err.response.status });
            }

            console.error(err);

            return error({ statusCode: StatusCodes.INTERNAL_SERVER_ERROR });
        }
    },

    computed: {
        ...mapGetters({
            selectedCampus: 'campuses/selectedCampus'
        }),

        isMoreAvailable() {
            return this.articles.length < this.total;
        }
    },

    watch: {
        selectedCampus() {
            this.resetArticles();
        },

        search() {
            this.resetArticles();
        }
    },

    methods: {
        ...mapActions({
            getArticles: 'articles/index'
        }),

        async fetchArticles(getMore = false) {
            try {
                this.page = getMore ? this.page + 1 : 1;

                const params = {
                    page: this.page,
                    perPage: this.perPage,
                    search: this.search,
                    tags: this.selectedTags
                };

                const { rows, count } = await this.getArticles(params);

                this.articles = getMore ? [...this.articles, ...rows] : rows;
                this.total = count;
            } catch (error) {
                console.error(error);

                this.$toasted.global.error();
            }
        },

        resetArticles() {
            this.page = 1;
            this.fetchArticles();
        },

        onTagClick(tagId) {
            if (!this.selectedTags.includes(tagId)) {
                this.selectedTags.push(tagId);

                return this.resetArticles();
            }

            const index = this.selectedTags.indexOf(tagId);

            this.selectedTags.splice(index, 1);

            this.resetArticles();
        }
    }
};
</script>
